import React from "react";
import { Mail, MessageCircle, InstagramIcon } from "lucide-react";
import { ContactCard } from "../commons/UI";
import { ChatPanel } from "../commons/Chat";
import { Ocultable } from "../commons/Ocultable";

export const Contacto = () => (
  <div className="mt-12" id="contacto">
    <h1 className="text-3xl md:text-4xl font-bold text-slate-100">Contacto</h1>
    <p className="text-slate-400 mt-2 max-w-2xl">Contanos brevemente sobre tu idea o necesidad y coordinamos una llamada.</p>

    <Ocultable enabled={false}>
      <section className="mt-12">
        <h2 className="text-2xl font-semibold text-slate-100">Chat de atención al cliente</h2>
        <ChatPanel className="mt-4" />
      </section>
    </Ocultable>

    <div className="mt-10 grid sm:grid-cols-2 gap-6">
      <ContactCard icon={<Mail className="w-5 h-5" />} title="Email" value="hola.velascosoft@gmail.com" onClick={() => { window.location.assign("mailto:hola.velascosoft@gmail.com"); }} />
      <Ocultable enabled={true}><ContactCard icon={<MessageCircle className="w-5 h-5" />} title="Whatsapp" value="+54 9" onClick={() => null} /></Ocultable>
      <ContactCard icon={<InstagramIcon className="w-5 h-5" />} title="Instagram" value="velasco.soft" onClick={() => window.open("https://www.instagram.com/velasco.soft", "__blank")} />
    </div>
  </div>
);
